var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hidden)?_c('header',{staticClass:"main-menu-bar"},[_c('menubar',{ref:"menu",attrs:{"model":_vm.items},scopedSlots:_vm._u([{key:"end",fn:function(){return [_c('span',{on:{"click":_vm.hide}},[_c('i',{staticClass:"pi pi-times"})])]},proxy:true}],null,false,881530555)})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11636b48","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/MainMenuBar.vue
// module id = null
// module chunks = 